var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYelStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.15327 2.83977L10.3266 5.18643C10.4866 5.5131 10.9133 5.82643 11.2733 5.88643L13.3999 6.23977C14.7599 6.46643 15.0799 7.4531 14.0999 8.42643L12.4466 10.0798C12.1666 10.3598 12.0133 10.8998 12.0999 11.2864L12.5733 13.3331C12.9466 14.9531 12.0866 15.5798 10.6533 14.7331L8.65994 13.5531C8.29994 13.3398 7.70661 13.3398 7.33994 13.5531L5.34661 14.7331C3.91994 15.5798 3.05327 14.9464 3.42661 13.3331L3.89994 11.2864C3.98661 10.8998 3.83327 10.3598 3.55327 10.0798L1.89994 8.42643C0.926606 7.4531 1.23994 6.46643 2.59994 6.23977L4.72661 5.88643C5.07994 5.82643 5.50661 5.5131 5.66661 5.18643L6.83994 2.83977C7.47994 1.56643 8.51994 1.56643 9.15327 2.83977Z",
    fill: "#FAC515"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYelStar);
export default __webpack_public_path__ + "static/media/yel-star.f2ee34a4378394fa4d594fcd7829713b.svg";
export { ForwardRef as ReactComponent };